import React from 'react';

import SourceBoxTable from './Table';

class SourceBoxSectionList extends React.PureComponent {
  renderTables(tables) {
    return tables.map((item, index) => {
      return (
        <SourceBoxTable
          data={ item.data }
          columns={ item.columns }
          key={ 'table-' + index }
          hideLargeDescriptions={ this.props.hideLargeDescriptions }
        />
      );
    });
  }

  renderSectionList() {
    return this.props.sections.map((item, index) => {
      return (
        <div className="panel panel-default" key={ index }>
          <div className="panel-heading">{ item.title }</div>
          <div className="panel-body">
            { this.props.legend }
            { this.renderTables(item.tables) }
            { item.footnote }
          </div>
        </div>
      );
    });
  }

  render() {
    return (
      <div className="panel-group">{ this.renderSectionList() }</div>
    );
  }
}

export default SourceBoxSectionList;



// WEBPACK FOOTER //
// ./src/components/SourceBox/SourceBoxSectionList.js